import { motion, useReducedMotion } from "framer-motion";
import { LeafSvg } from "./Leaf";

// top in %, size in px, delay/duration in s, rise = vertical drift in vh
const LEAVES = [
  { top: 18, size: 26, delay: 0.6, dur: 6.5, rise: -12, color: "#DCEFBE" },
  { top: 34, size: 18, delay: 1.0, dur: 5.8, rise: -18, color: "#9BC86A" },
  { top: 52, size: 30, delay: 0.3, dur: 7.2, rise: -10, color: "#C8A26B" },
  { top: 64, size: 16, delay: 1.5, dur: 6.0, rise: -22, color: "#DCEFBE" },
  { top: 26, size: 22, delay: 2.0, dur: 6.8, rise: -8, color: "#6E9A3C" },
  { top: 72, size: 24, delay: 0.9, dur: 7.5, rise: -16, color: "#9BC86A" },
  { top: 44, size: 14, delay: 2.4, dur: 5.5, rise: -14, color: "#DCEFBE" },
];

export const WindLeaves = () => {
  const reduce = useReducedMotion();
  if (reduce) return null;
  return (
    <div data-testid="hero-wind-leaves" aria-hidden="true" className="pointer-events-none absolute inset-0 z-[5] overflow-hidden">
      {LEAVES.map((l, i) => (
        <motion.div
          key={i}
          className="absolute left-0 will-change-transform"
          style={{ top: `${l.top}%`, width: l.size, height: l.size * 1.5 }}
          initial={{ x: "-8vw", y: 0, rotate: -40, opacity: 0 }}
          animate={{
            x: ["-8vw", "25vw", "55vw", "85vw", "112vw"],
            y: ["0vh", `${l.rise * 0.4}vh`, `${l.rise * 0.2}vh`, `${l.rise * 0.8}vh`, `${l.rise}vh`],
            rotate: [-40, 60, 160, 250, 380],
            opacity: [0, 0.95, 0.95, 0.85, 0],
          }}
          transition={{ duration: l.dur, delay: l.delay, ease: "easeInOut", times: [0, 0.25, 0.5, 0.75, 1] }}
        >
          <LeafSvg color={l.color} />
        </motion.div>
      ))}
    </div>
  );
};
